<div class="mat-elevation-z8">
  <table mat-table [dataSource]="dataSource" matSort>
    <!--- Note that these columns can be defined in any order.
          The actual rendered columns are set as a property on the row definition" -->

    <!-- Country Column -->
    <ng-container matColumnDef="country">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Country</th>
      <td mat-cell *matCellDef="let element">{{ element.Country }}</td>
    </ng-container>

    <!-- Total Confirmed Column -->
    <ng-container matColumnDef="totalConfirmed">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Total Confirmed</th>
      <td mat-cell *matCellDef="let element">
        {{ element.TotalConfirmed | number }}
      </td>
    </ng-container>

    <!-- Total Deaths Column -->
    <ng-container matColumnDef="totalDeaths">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Total Deaths</th>
      <td mat-cell *matCellDef="let element">
        {{ element.TotalDeaths | number }}
      </td>
    </ng-container>

    <!-- Total Recovered Column -->
    <ng-container matColumnDef="totalRecovered">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Total Recovered</th>
      <td mat-cell *matCellDef="let element">
        {{ element.TotalRecovered | number }}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr
      mat-row
      (click)="clickedRows(row)"
      *matRowDef="let row; columns: displayedColumns"
    ></tr>
  </table>

  <mat-paginator
    [pageSizeOptions]="[5, 10, 25, 100]"
    showFirstLastButtons
    aria-label="Select page of users"
  ></mat-paginator>
</div>
<div *ngIf="isShow" class="loader">
  <mat-spinner></mat-spinner>
</div>
